import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { authService } from "@/services/authService";
import useToastStore from "@/components/Common/Toast/toastStore";

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  // password: Yup.string()
  //   .min(6, "Password must be at least 6 characters")
  //   .required("Password is required"),
});

const Login = () => {
  const navigate = useNavigate();
  const { showToast } = useToastStore;
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await authService.login({
        email: values.email,
        // password: values.password,
      });

      console.log("Full login response:", response);
      // Try to find the token in different possible locations
      const tempToken =
        response?.meta?.temp_token ||
        response?.data?.temp_token ||
        response?.temp_token;

      console.log("Found tempToken:", tempToken);

      showToast({ message: "OTP sent to your email", type: "success" });
      navigate(
        `/auth/verify-otp?email=${encodeURIComponent(values.email)}&temp_token=${tempToken}`,
      );
    } catch (error) {
      // Display validation errors from Yup
      if (error.name === "ValidationError") {
        showToast({ message: error.message, type: "error" });
        return;
      }

      // Handle backend errors
      if (error.response?.data) {
        const { errors, error: errorObj, message } = error.response.data;

        if (errors || errorObj) {
          // Handle structured error objects
          const errorMessages = Object.values(errors || errorObj).flat();
          errorMessages.forEach((msg) =>
            showToast({ message: msg, type: "error" }),
          );
        } else if (message) {
          // Handle simple message error
          showToast({ message: message, type: "error" });
        }
      } else {
        // Handle generic errors
        showToast({ message: error.message || "Login failed", type: "error" });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-primary/10 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl w-full space-y-8 bg-card p-10 rounded-xl shadow-lg">
        <div className="-mx-4 flex flex-wrap items-center">
          <div className="w-full px-4 lg:w-1/2">
            <div className="text-center grayscale">
              <img
                src="https://cdn.tailgrids.com/2.0/image/application/images/forms/forms-10.svg"
                alt="illustration"
                className="mx-auto"
              />
            </div>
          </div>
          {/* Right side with illustration */}
          <div className="w-full px-4 lg:w-1/2">
            <div>
              <h2 className=" text-3xl font-extrabold text-foreground">App TRKR</h2>
              <p className="mt-2 text-sm text-foreground mb-4">
                Sign in to your account to continue
              </p>
            </div>

            <Formik
              initialValues={{
                email: "",
                // password: "",
                rememberMe: false,
              }}
              validationSchema={LoginSchema}
              onSubmit={handleSubmit}
            >
              {({
                errors,
                touched,
                isSubmitting,
                getFieldProps,
                values,
                setFieldValue,
              }) => (
                <Form className="space-y-3">
                  <div className="rounded-md">
                    <div className="mb-4">
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-foreground"
                      >
                        Email Address
                      </label>
                      <input
                        id="email"
                        type="email"
                        {...getFieldProps("email")}
                        className="mt-1 appearance-none relative block w-full px-3 py-2 border border-input bg-background text-foreground placeholder:text-muted-foreground/50 rounded-md focus:outline-none focus:ring-1 focus:ring-ring focus:border-input focus:z-10 sm:text-sm"
                        placeholder="Enter your email"
                      />
                      {touched.email && errors.email && (
                        <p className="mt-2 text-sm text-red-600">
                          {errors.email}
                        </p>
                      )}
                    </div>
                    {/* 
                    <div className="-mb-[6px]">
                      <label htmlFor="password" className="block text-sm font-medium text-foreground">
                        Password
                      </label>
                      <input
                        id="password"
                        type="password"
                        {...getFieldProps("password")}
                        className="mt-1 appearance-none relative block w-full px-3 py-2 border border-input bg-background text-foreground placeholder:text-muted-foreground/50 rounded-md focus:outline-none focus:ring-1 focus:ring-ring focus:border-input focus:z-10 sm:text-sm"
                        placeholder="Enter your password"
                      />
                      {touched.password && errors.password && (
                        <p className="mt-2 text-sm text-red-600">{errors.password}</p>
                      )}
                    </div> */}
                  </div>

                  {/* Forgot password & I am candidate - commented out
                  <div className="flex items-center justify-between">
                    <div className="text-sm flex items-center justify-between w-full">
                      <a href="/auth/forgot-password" className="font-medium text-foreground hover:text-[#5BA88C]">
                        Forgot your password?
                      </a>
                      <div className="flex items-center ml-4">
                        <input
                          id="candidate-login"
                          name="candidate-login"
                          type="checkbox"
                          checked={values.candidateLogin}
                          onChange={() => setFieldValue("candidateLogin", !values.candidateLogin)}
                          className="h-4 w-4 text-foreground focus:ring-[#5BA88C] border-brand rounded"
                        />
                        <label htmlFor="candidate-login" className="ml-2 block text-sm text-foreground">
                          I am a candidate
                        </label>
                      </div>
                    </div>
                  </div>
                  */}

                  <div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-dark hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-150 hover:scale-[1.02]"
                    >
                      {isSubmitting ? (
                        <span className="flex items-center">
                          <svg
                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Signing in...
                        </span>
                      ) : (
                        "Sign in"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
